<!-- Step 1: Select Device -->
<div *ngIf="currentStep === 1" class="nmi-pos-step">
  <h4 class="nmi-pos-step__title">Select Terminal</h4>

  <div *ngIf="loadingDevices" class="nmi-pos-loading">Loading terminals...</div>

  <div *ngIf="!loadingDevices && devices.length === 0" class="nmi-pos-empty">
    No terminals registered. Please ask your administrator to set up a POS terminal.
  </div>

  <div *ngIf="!loadingDevices && devices.length > 0">
    <div *ngFor="let device of devices; trackBy: trackByDeviceId"
      class="nmi-pos-device-row"
      [class.nmi-pos-device-row--selected]="selectedDeviceId === device.poi_device_id"
      (click)="selectedDeviceId = device.poi_device_id">
      <span class="nmi-pos-device-row__indicator"
        [class.nmi-pos-device-row__indicator--connected]="device.is_connected"></span>
      <span class="nmi-pos-device-row__name">{{ device.device_nickname }}</span>
      <span class="nmi-pos-device-row__status">({{ device.registration_status }})</span>
    </div>

    <div class="nmi-pos-actions">
      <button class="nmi-pos-btn nmi-pos-btn--primary"
        [disabled]="!selectedDeviceId || saleAmount <= 0" (click)="goToStep2()">
        Next
      </button>
    </div>
  </div>
</div>

<!-- Step 2: Enter Amount -->
<div *ngIf="currentStep === 2" class="nmi-pos-step">
  <h4 class="nmi-pos-step__title">Payment Details</h4>

  <div class="nmi-pos-field">
    <label class="nmi-pos-label">Amount ($)</label>
    <input class="nmi-pos-input" type="number" min="0.01" step="0.01"
      [(ngModel)]="saleAmount" placeholder="0.00" />
  </div>

  <div class="nmi-pos-field">
    <label class="nmi-pos-label">Type</label>
    <div class="nmi-pos-radio-group">
      <label><input type="radio" name="posSaleType" [(ngModel)]="saleType" value="sale" /> Sale</label>
      <label><input type="radio" name="posSaleType" [(ngModel)]="saleType" value="auth" /> Auth Only</label>
    </div>
  </div>

  <div class="nmi-pos-actions nmi-pos-actions--split">
    <button class="nmi-pos-btn nmi-pos-btn--secondary" (click)="backToStep1()">Back</button>
    <button class="nmi-pos-btn nmi-pos-btn--primary"
      [disabled]="!saleAmount || saleAmount <= 0" (click)="startPayment()">
      Charge ${{ saleAmount | number:'1.2-2' }} on Terminal
    </button>
  </div>
</div>

<!-- Step 3: Processing -->
<div *ngIf="currentStep === 3" class="nmi-pos-step nmi-pos-step--centered">
  <div class="nmi-pos-spinner"></div>
  <p class="nmi-pos-status-text">Waiting for customer on terminal...</p>
  <p class="nmi-pos-elapsed">{{ elapsedSeconds }}s elapsed</p>
  <p class="nmi-pos-hint">To cancel, press Cancel on the terminal.</p>
</div>

<!-- Step 4: Result -->
<div *ngIf="currentStep === 4" class="nmi-pos-step nmi-pos-step--centered">

  <!-- Success -->
  <ng-container *ngIf="paymentSucceeded">
    <div class="nmi-pos-result nmi-pos-result--success">&#10003;</div>
    <p class="nmi-pos-result-label nmi-pos-result-label--success">Approved</p>
    <dl class="nmi-pos-details" *ngIf="displayTransactionId || displayAuthCode">
      <ng-container *ngIf="saleAmount">
        <dt>Amount</dt><dd>${{ saleAmount | number:'1.2-2' }}</dd>
      </ng-container>
      <ng-container *ngIf="displayTransactionId">
        <dt>Transaction ID</dt><dd>{{ displayTransactionId }}</dd>
      </ng-container>
      <ng-container *ngIf="displayAuthCode">
        <dt>Auth Code</dt><dd>{{ displayAuthCode }}</dd>
      </ng-container>
    </dl>
    <div class="nmi-pos-actions">
      <button class="nmi-pos-btn nmi-pos-btn--success" (click)="done()">Done</button>
    </div>
  </ng-container>

  <!-- Failure -->
  <ng-container *ngIf="!paymentSucceeded">
    <div class="nmi-pos-result nmi-pos-result--failure">&#10007;</div>
    <p class="nmi-pos-result-label nmi-pos-result-label--failure">
      {{ finalStatus?.async_status === 'error' ? 'Error' : finalStatus?.async_status === 'cancelledAtTerminal' ? 'Cancelled' : 'Declined' }}
    </p>
    <p class="nmi-pos-error-text" *ngIf="finalStatus?.async_status === 'cancelledAtTerminal'">Payment cancelled at terminal.</p>
    <p class="nmi-pos-error-text" *ngIf="finalStatus?.async_status !== 'cancelledAtTerminal' && displayResponseText">{{ displayResponseText }}</p>
    <div class="nmi-pos-actions nmi-pos-actions--split">
      <button class="nmi-pos-btn nmi-pos-btn--secondary" (click)="done()">Done</button>
      <button class="nmi-pos-btn nmi-pos-btn--primary" (click)="tryAgain()">Try Again</button>
    </div>
  </ng-container>

</div>
